module.exports = "<div class=\"ssoContainer\">\r\n    <table class=\"middleContainer\">\r\n        <tr>\r\n            <td>\r\n                <sso />\r\n            </td>\r\n        </tr>\r\n    </table>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/component/sso/ssoIndex.html
// module id = 185
// module chunks = 0